import React from 'react';
import { ValidatedInput } from '@cp-shared-19/frontend-ui';

type EmailProps = {
    label: string;
    name: string;
    inputId?: string;
    isMandatory?: boolean;
};

export const EmailInput: React.FC<EmailProps> = ({ label, name, isMandatory = true, inputId }) => {
    return (
        <ValidatedInput
            className="c-form-field--no-floating"
            label={label}
            name={name}
            inputMode={'email'}
            testId={`test-${name}`}
            inputId={inputId}
            aria-required={isMandatory}
            isMandatory={isMandatory}
            requiredText=" *"
            autocomplete="email"
        />
    );
};
